import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PlayIcon, PauseIcon, MinusIcon, PlusIcon, ArrowUpIcon, ArrowDownIcon, RefreshCwIcon } from 'lucide-react';
import PageHeader from '../components/PageHeader';
interface ControllerPageProps {
  isScrolling: boolean;
  toggleScrolling: () => void;
  scrollSpeed: number;
  setScrollSpeed: (speed: number) => void;
  fontSize: number;
  setFontSize: (size: number) => void;
}
const ControllerPage: React.FC<ControllerPageProps> = ({
  isScrolling,
  toggleScrolling,
  scrollSpeed,
  setScrollSpeed,
  fontSize,
  setFontSize
}) => {
  const navigate = useNavigate();
  const decreaseSpeed = () => {
    if (scrollSpeed > 1) {
      setScrollSpeed(scrollSpeed - 1);
    }
  };
  const increaseSpeed = () => {
    setScrollSpeed(scrollSpeed + 1);
  };
  const handlePlaybackToggle = () => {
    toggleScrolling();
  };
  // These functions would be implemented to control scrolling position
  const scrollUp = () => {
    // In a real implementation, this would scroll the teleprompter up
    alert('Scroll Up functionality would be implemented here');
  };
  const scrollDown = () => {
    // In a real implementation, this would scroll the teleprompter down
    alert('Scroll Down functionality would be implemented here');
  };
  return <div className="flex-1 flex flex-col" data-id="element-176">
      <PageHeader title="Controller" rightContent={<button onClick={() => navigate('/sync')} className="text-[#51a7fa] hover:text-white" data-id="element-178">
            <RefreshCwIcon size={24} data-id="element-179" />
          </button>} data-id="element-177" />
      <div className="flex-1 p-5 flex flex-col items-center justify-center" data-id="element-180">
        <div className="w-full max-w-md space-y-4" data-id="element-181">
          {/* Start/Stop Scrolling Button */}
          <button onClick={handlePlaybackToggle} className="w-full bg-blue-900 text-white py-4 rounded-lg flex items-center justify-center text-lg" data-id="element-182">
            {isScrolling ? <>
                <PauseIcon size={28} className="mr-2" data-id="element-183" />
                Stop Scrolling
              </> : <>
                <PlayIcon size={28} className="mr-2" data-id="element-184" />
                Start Scrolling
              </>}
          </button>
          {/* Seek Controls */}
          <div className="bg-gray-900 p-4 rounded-lg" data-id="element-185">
            <div className="flex items-center justify-between" data-id="element-186">
              <button onClick={scrollUp} className="bg-gray-800 text-white p-6 rounded-lg" data-id="element-187">
                <ArrowUpIcon size={32} data-id="element-188" />
              </button>
              <div className="flex-1 flex flex-col items-center" data-id="element-189">
                <div className="text-lg font-bold" data-id="element-190">Seek</div>
              </div>
              <button onClick={scrollDown} className="bg-gray-800 text-white p-6 rounded-lg" data-id="element-191">
                <ArrowDownIcon size={32} data-id="element-192" />
              </button>
            </div>
          </div>
          {/* Scroll Speed Controls */}
          <div className="bg-gray-900 p-4 rounded-lg" data-id="element-193">
            <div className="flex items-center justify-between" data-id="element-194">
              <button onClick={decreaseSpeed} className="bg-gray-800 text-white p-6 rounded-lg" data-id="element-195">
                <MinusIcon size={32} data-id="element-196" />
              </button>
              <div className="flex-1 flex flex-col items-center" data-id="element-197">
                <div className="text-3xl font-bold" data-id="element-198">{scrollSpeed}</div>
                <div className="text-sm text-gray-400" data-id="element-199">Scroll Speed</div>
              </div>
              <button onClick={increaseSpeed} className="bg-gray-800 text-white p-6 rounded-lg" data-id="element-200">
                <PlusIcon size={32} data-id="element-201" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default ControllerPage;